import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Col, Row, Select } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NAMESPACES, SideBarSettings, TabMenuHeader } from '../LinkBlockDesign/LinkBlockSidebar';
import { EMAIL_DESIGN_ELEMENTS_SIDEBAR } from '../../EmailDesignPage/EmailBuilder/translationValues';
import * as palette from '../../../styles/variables';
import TextBlockWithQuillRenderer from '../../ComplexDocumentDesign/TextBlockWithQuillRenderer';
import { constructAutoSaveJSON, constructQuillJSON } from '../../../utils/TextBlockHelper';
import { dummyCallback } from './ButtonBlock';
import { deepCopy } from '../../../utils/javascript';

const defaultStyles = [
  {
    linkStyles: {
      isButton: true,
      innerPadding: '10px 10px 10px 10px',
      buttonBg: '#fff',
      align: 'left',
      color: '#000000',
    },
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><strong style="color: rgb(0, 0, 0); letter-spacing: 0px;"><u>Read more &gt;&gt;</u></strong></p>',
  },
  {
    linkStyles: {
      isButton: true,
      innerPadding: '10px 25px 10px 25px',
      buttonBg: '#ffffff',
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: 'black',
      align: 'left',
      boxShadow:
        'inset 2px 2px 2px 0px rgba(255,255,255,.5), 7px 7px 20px 0px rgba(0,0,0,.1), 4px 4px 5px 0px rgba(0,0,0,.1)',
      color: '#000000',
    },
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(0, 0, 0);"><strong>Read more</strong></span></p>',
  },
  {
    linkStyles: {
      isButton: true,
      innerPadding: '10px 25px 10px 25px',
      buttonBg: 'rgb(6,14,131)',
      borderRadius: '5px',
      align: 'left',
      bgGradient: 'linear-gradient(0deg, rgba(6,14,131,1) 0%, rgba(12,25,180,1) 100%)',
      boxShadow:
        'inset 2px 2px 2px 0px rgba(255,255,255,.5), 7px 7px 20px 0px rgba(0,0,0,.1), 4px 4px 5px 0px rgba(0,0,0,.1)',
      color: '#ffffff',
    },
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(255, 255, 255);">Read more</span></p>',
  },
  {
    linkStyles: {
      isButton: true,
      innerPadding: '10px 25px 10px 25px',
      buttonBg: 'rgb(96,9,240)',
      borderRadius: '20px',
      align: 'left',
      bgGradient: 'linear-gradient(0deg, rgba(96,9,240,1) 0%, rgba(129,5,240,1) 100%)',
      boxShadow:
        'inset 2px 2px 2px 0px rgba(255,255,255,.5), 7px 7px 20px 0px rgba(0,0,0,.1), 4px 4px 5px 0px rgba(0,0,0,.1)',
      color: '#ffffff',
    },
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(255, 255, 255);">Read more!!</span></p>',
  },
  {
    linkStyles: {
      isButton: true,
      innerPadding: '10px 25px 10px 25px',
      buttonBg: 'rgb(0,172,238)',
      align: 'left',
      borderRadius: '20px',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      bgGradient: 'linear-gradient(0deg, rgba(0,172,238,1) 0%, rgba(2,126,251,1) 100%)',
      color: '#ffffff',
    },
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(255, 255, 255);"><strong>Read more</strong></span></p>',
  },
  {
    linkStyles: {
      isButton: true,
      innerPadding: '10px 25px 10px 25px',
      buttonBg: '#4dccc6',
      align: 'left',
      borderRadius: '1px',
      bgGradient: 'linear-gradient(315deg, #4dccc6 0%, #96e4df 74%)',
      color: '#ffffff',
    },
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(255, 255, 255);"><strong>READ MORE</strong></span></p>',
  },
  {
    linkStyles: {
      isButton: true,
      innerPadding: '10px 25px 10px 25px',
      buttonBg: 'rgb(255,27,0)',
      borderRadius: '5px 25px 5px 25px',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      align: 'left',
      bgGradient: 'linear-gradient(0deg, rgba(255,27,0,1) 0%, rgba(251,75,2,1) 100%)',
      color: '#ffffff',
    },
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(255, 255, 255);"><strong>Read more</strong></span></p>',
  },
  {
    linkStyles: {
      isButton: true,
      innerPadding: '10px 25px 10px 25px',
      buttonBg: 'rgb(118,174,241)',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'rgb(118,174,241)',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      align: 'left',
      color: '#ffffff',
    },
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(255, 255, 255);"><strong>Read more</strong></span></p>',
  },
];

const getButtonStyles = linkStyles => {
  if (linkStyles.isButton) {
    const styles = {
      backgroundColor: linkStyles.buttonBg,
      padding: linkStyles.innerPadding,
      width: 'fit-content',
      display: 'inline-block',
    };
    if (linkStyles.boxShadow) {
      styles['boxShadow'] = linkStyles.boxShadow;
    }
    if (linkStyles.borderWidth) {
      styles['borderWidth'] = linkStyles.borderWidth;
      styles['borderStyle'] = linkStyles.borderStyle;
      styles['borderColor'] = linkStyles.borderColor;
    }
    if (linkStyles.borderRadius) {
      styles['borderRadius'] = linkStyles.borderRadius;
    }
    if (linkStyles.bgGradient) {
      styles['background'] = linkStyles.bgGradient;
    }
    return styles;
  }
  return {};
};

const Option = Select.Option;

const TabMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => (props.isSaveFolder ? '50px' : '150px')};
  height: ${props => props.variableSidebar && '100%'};
  width: ${props => props.complexDesign && '90%'};
  margin: ${props => props.complexDesign && 'auto'};
  .addAttachmentsButton {
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    width: 200px;
    height: 40px;
    text-align: center;
    border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
    color: #000;
    font-weight: 500;
    border-radius: 15px;
    z-index: 10 !important;
    &:hover,
    &:focus {
      border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
      background: ${palette.APP_BRAND_YELLOW_COLOR};
      color: #000;
    }
  }
  &.mailSettings {
    width: 100%;
    align-items: ${props => props.addAttachment && 'center'};
    margin-bottom: 0px !important;
    .ant-input {
      min-height: 55%;
      height: 70%;
      font-size: 15px;
    }
  }
  &.fixedHeight {
    width: 100%;
    align-items: ${props => props.addAttachment && 'center'};
    margin-bottom: 0px !important;
    height: calc(100% - 60px);
  }
  .categoryContainer {
    margin-top: 88px;
    overflow: auto;
    max-height: 48vh;
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
    @media only screen and (max-width: 1440px) {
      max-height: 45vh;
    }
  }
  &.attachmentTemp {
    align-items: center;
    h2 {
      font-size: 16px !important;
      font-weight: 600;
    }
  }

  .manage-setting-input {
    margin-top: 10px;
    margin-bottom: 20px;
    height: 40px;
    i[aria-label='icon: search'] {
      display: none;
    }
  }
  .warning-message {
    color: orange;
    font-size: 14px;
    margin-top: -10px;
    margin-bottom: 10px;
  }
`;

const TabMenuItemContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.columnDirection ? 'column' : 'row')};
  flex-wrap: wrap;
  padding-right:0px !important;
  margin-bottom: ${props => (props.subject ? '0' : props.addAttachment ? '100px' : '10px')};
  margin-top: ${props => props.isSearchView && '80px'};
  position: relative;
  z-index: 101;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'center')};
  align-items: ${props => (props.subject ? 'flex-start' : 'center')};
  
  .buttonItem {
    margin: 10px 0 0 10px;
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border: 1px solid rgba(14, 19, 24, 0.7);
    width: 70%;
    height: 50px;
    border-radius: 10px;
    
    .overflowText {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .ant-select-selection {
    background-color: #fc6e511c;
    color: #fff;
    border: 1.9px solid hsla(0,0%,100%,0.4);  
    margin: 5px 0;
    font-size: 15px;
    font-weight: 600;
  }
  .ant-select-arrow {
    color: #fff !important;
  }
  .ant-select-selection:hover{
    border:1.5px solid #fff !important; 
  }
  .ant-select-selection:focus, .ant-select-selection:active {
    border-color: #fff;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: none !important;
  }  
  .ant-select-disabled .ant-select-selection {
    background: #f5f5f5;
    cursor: not-allowed;
    color: #c7c7c7 !important;
    font-weight: 500 !important;
  }
`;

const IconMenuItem = styled.div`
  flex: 1;
  min-width: 120px;
  min-height: 120px;
  margin: 10px;
  text-align: center;
  transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;

  &:hover {
    cursor: pointer;
    transform: scale(1.05) translate(0px, 0px) perspective(500px);

    .dropdown-menu {
      display: flex;
    }
  }

  .anticon {
    font-size: 45px;
    @media only screen and (max-width: 1460px) {
      font-size: 35px !important;
    }
  }

  .ql-editor * {
    cursor: pointer;
  }
  &.mailElements {
    min-height: 0 !important;
  }
`;

const ButtonGalleryItem = styled.div`
  .ql-editor {
    padding: 0;
  }
`;

const ButtonBlockSidebarSettings = ({ buttonBlock, globalVariables, parentUUID, store }) => {
  const { uuid, style, type: blockType, contents: blockContents } = buttonBlock;
  const { type = 'web', contents, align } = style.linkStyles;
  const { t } = useTranslation(NAMESPACES);
  const [textEditable, setTextEditable] = useState(false);
  const [randomKey, setRandomKey] = useState(1);
  const [canUpdateRandomKey, setCanUpdateRandomKey] = useState(true);

  useEffect(() => {
    if (canUpdateRandomKey) {
      setRandomKey(value => value + 1);
    }
  }, [style.linkStyles, canUpdateRandomKey]);

  const updateContent = (
    elContents,
    undoDiff,
    redoDiff,
    cb,
    ref,
    op = undefined,
    newGlobalVariables = [],
  ) => {
    const newContents = constructAutoSaveJSON(elContents, undefined, undefined, newGlobalVariables);
    const newValue = { ...style.linkStyles, contents: newContents };

    store.updateBlock('linkStyles', uuid, {
      linkStyles: { data: newValue },
      flowUUID: parentUUID,
      type: blockType,
    });
  };

  let inputLabel;
  switch (type) {
    case 'email':
      inputLabel = t(
        EMAIL_DESIGN_ELEMENTS_SIDEBAR.EMAIL_ADDRESS_INPUT_LABEL.key,
        EMAIL_DESIGN_ELEMENTS_SIDEBAR.EMAIL_ADDRESS_INPUT_LABEL.value,
      );
      break;
    case 'call':
    case 'sms':
      inputLabel = t(
        EMAIL_DESIGN_ELEMENTS_SIDEBAR.PHONE_NUMBER_INPUT_LABEL.key,
        EMAIL_DESIGN_ELEMENTS_SIDEBAR.PHONE_NUMBER_INPUT_LABEL.value,
      );
      break;
    default:
      inputLabel = t(
        EMAIL_DESIGN_ELEMENTS_SIDEBAR.LINK_INPUT_LABEL.key,
        EMAIL_DESIGN_ELEMENTS_SIDEBAR.LINK_INPUT_LABEL.value,
      );
      break;
  }

  const updateLinkStyles = tempValue => {
    const newValue = { ...tempValue, type, contents, align };
    const storeObj = {
      linkStyles: { data: newValue },
      flowUUID: parentUUID,
      type: blockType,
      op: 'update',
    };
    if (tempValue.color) {
      storeObj.linkStyles.contents = deepCopy(blockContents).map(content => {
        if (content.style) {
          content.style.color = tempValue.color;
        }
        return content;
      });
    }
    store.updateBlock('linkStyles', uuid, storeObj);
  };

  const updateLinkType = tempValue => {
    const newValue = { ...style.linkStyles, type: tempValue };
    store.updateBlock('linkStyles', uuid, {
      linkStyles: { data: newValue },
      flowUUID: parentUUID,
      type: blockType,
    });
  };

  return (
    <SideBarSettings
      onMouseEnter={() => setCanUpdateRandomKey(false)}
      onMouseLeave={() => setCanUpdateRandomKey(true)}
    >
      <Row type="flex" justify={'end'}>
        <Col span={10}>
          <Select defaultValue={'web'} value={type} onChange={type => updateLinkType(type)}>
            <Option key="left" value="web">
              {t(
                EMAIL_DESIGN_ELEMENTS_SIDEBAR.OPEN_WEBSITE_LINK_DROPDOWN_VALUE.key,
                EMAIL_DESIGN_ELEMENTS_SIDEBAR.OPEN_WEBSITE_LINK_DROPDOWN_VALUE.value,
              )}
            </Option>
            <Option key="center" value="email">
              {t(
                EMAIL_DESIGN_ELEMENTS_SIDEBAR.SEND_EMAIL_LINK_DROPDOWN_VALUE.key,
                t(EMAIL_DESIGN_ELEMENTS_SIDEBAR.SEND_EMAIL_LINK_DROPDOWN_VALUE.value),
              )}
            </Option>
            <Option key="right" value="call">
              {t(
                EMAIL_DESIGN_ELEMENTS_SIDEBAR.CALL_PHONE_LINK_DROPDOWN_VALUE.key,
                t(EMAIL_DESIGN_ELEMENTS_SIDEBAR.CALL_PHONE_LINK_DROPDOWN_VALUE.value),
              )}
            </Option>
          </Select>
        </Col>
      </Row>
      <TabMenuHeader inverted={1}>{inputLabel}</TabMenuHeader>
      <div id="button-block-toolbar" style={{ visibility: 'hidden', height: 0 }} />
      <div id={`button-block-sidebar-variable`} style={{ position: 'relative', top: 10 }} />
      <div>
        <TextBlockWithQuillRenderer
          key={randomKey}
          defaultContent={constructQuillJSON(contents, null, null, globalVariables)}
          saveBlock={updateContent}
          itemUUID={uuid}
          selected={true}
          enableSideBar={dummyCallback}
          enableAI={false}
          toolbarInvisible={true}
          adjustScroll={dummyCallback}
          textEditable={textEditable}
          setTextEditable={setTextEditable}
          toolbarDOM={'button-block-toolbar'}
          variableDOM={`button-block-sidebar-variable`}
          exposeRef={false}
        />
      </div>
      <TabMenuHeader inverted={1}>
        {t(
          EMAIL_DESIGN_ELEMENTS_SIDEBAR.BUTTON_DEFAULT_STYLES_HEADING.key,
          EMAIL_DESIGN_ELEMENTS_SIDEBAR.BUTTON_DEFAULT_STYLES_HEADING.value,
        )}
      </TabMenuHeader>
      <TabMenuContainer>
        <TabMenuItemContainer columnDirection={false}>
          <>
            {defaultStyles.map((defaultButton, index) => (
              <IconMenuItem
                key={`default-button-style-${index}`}
                onClick={() => updateLinkStyles(defaultButton.linkStyles)}
              >
                <ButtonGalleryItem style={getButtonStyles(defaultButton.linkStyles)}>
                  <div
                    className={'ql-editor'}
                    dangerouslySetInnerHTML={{ __html: defaultButton.value }}
                  />
                </ButtonGalleryItem>
              </IconMenuItem>
            ))}
          </>
        </TabMenuItemContainer>
      </TabMenuContainer>
    </SideBarSettings>
  );
};

export const ButtonBlockSidebar = ({ closeSidebar, ...props }) => {
  return (
    <>
      {ReactDOM.createPortal(
        <ButtonBlockSidebarSettings {...props} />,
        document.getElementById('sidebar-absolute-container'),
      )}
      {ReactDOM.createPortal(
        <div
          className="layoutbtn-container"
          onClick={closeSidebar}
          style={{ position: 'absolute', top: 0, left: -2 }}
        >
          <Icon type={'close'} />
        </div>,
        document.getElementById('sidebar-absolute-close'),
      )}
    </>
  );
};
